import { css, cva } from '@landr/styled-system/css';

export const chipStyles = cva({
    base: {
        height: 'sm',
        '&[data-state="checked"]': {
            backgroundColor: 'surface.neutral.high',
            color: 'text.inverted',
            _hover: {
                backgroundColor: 'surface.neutral.high.hover',
            },
        },
    },
    variants: {
        isDisabled: {
            true: {
                _hover: {
                    backgroundColor: 'inherit',
                },
            },
            false: {
                _hover: {
                    backgroundColor: 'surface.inverted',
                    color: 'text.inverted.high',
                },
            },
        },
    },
    defaultVariants: {
        isDisabled: false,
    },
});

export const disabledCheckboxWrapperStyles = css({
    '& .checkbox-disabled': {
        pointerEvents: 'none',
    },
    '& .checkbox-disabled:hover': {
        backgroundColor: 'inherit !important',
        borderColor: 'inherit !important',
        color: 'inherit !important',
    },
});

export const sharpsAndFlatsContainerStyles = cva({
    base: {
        position: 'relative',
    },
    variants: {
        index: {
            0: { marginLeft: 'lg' },
            1: { marginRight: 'jb' },
        },
    },
});

export const toggleGridStyles = css({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr 1fr',
    position: 'relative',
    width: 'xxl',
    height: 'xxl',
});

export const toggleContainerStyles = css({
    width: 'xxl',
    height: 'xxl',
});

export const toggleTextStyles = css({
    display: 'block',
    lineHeight: '18px',
    minWidth: '16px',
    margin: 'unset',
    gridColumn: '1',
    gridRow: '1',
});

export const toggleButtonStylesV3 = css({
    padding: 0,
    borderColor: 'border.high',
    cursor: 'click',

    '&[aria-pressed="true"]': {
        backgroundColor: 'surface.inverted',
        _hover: {
            backgroundColor: 'surface.neutral.high.hover',
        },
    },

    _hover: {
        borderColor: 'border.high',
        backgroundColor: 'surface.inverted',
        color: 'text.inverted.high',

        '& span': {
            borderColor: 'border.low',
        },
    },
});

export const toggleDiagonalLineStylesV3 = css({
    position: 'absolute',
    left: 0,
    bottom: '50%',
    borderBottom: '1px solid',
    borderColor: 'border.high',
    transform: 'rotate(-45deg)',
    transformOrigin: 'bottom',
    width: '100%',
    transition: 'all 300ms ease-in-out',
});
